import { useListEntityApi } from "@/common/api/listEntityApi";
import type { ReleaseNoteResponse } from "./models/releaseNoteResponse";

export function useListReleaseNoteApi() {
  return useListEntityApi({
    url: 'releaseNote',
    excludeSite: true,
    translate: (t) => t.releaseNotes.actions.fetchMany,
    async processOk(response) {
      const notes = await response.json() as ReleaseNoteResponse[];
      return {
        ok: true,
        notes: notes
      };
    },
  })
}
